import { render, staticRenderFns } from "./indonesia.vue?vue&type=template&id=60937259&scoped=true"
import script from "./indonesia.vue?vue&type=script&lang=js"
export * from "./indonesia.vue?vue&type=script&lang=js"
import style0 from "./indonesia.vue?vue&type=style&index=0&id=60937259&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60937259",
  null
  
)

export default component.exports